import { tsr } from "~/utils/client";

export const useGetActivityScheduleQuery = (scheduleId: string) =>
  tsr.activitySchedules.get.useQuery({
    queryKey: ["activity-schedules", scheduleId],
    queryData: {
      params: { id: scheduleId },
    },
  });
